import { cn } from '@shared/components/ui/cn';

import { LOGO_ASSETS, brandColour } from './logos';

interface ConnectorLogoProps {
  /** The catalog's `logo.key`. */
  logoKey: string | undefined;
  /** The catalog's `logo.brandColor`. */
  brandColor?: string;
  /** The service's name: its initial fills the badge of a key with no asset. */
  name: string;
  className?: string;
}

/**
 * A connector's logo: the bundled mark for its key, drawn in the brand colour, else the brand
 * colour's badge with the service's initial (the catalog's fallback).
 */
export function ConnectorLogo({ logoKey, brandColor, name, className }: ConnectorLogoProps) {
  const asset = logoKey ? LOGO_ASSETS.get(logoKey) : undefined;
  const colour = brandColour(brandColor);
  if (asset) {
    const image = `url("${asset}")`;
    return (
      <span
        aria-hidden="true"
        data-logo={logoKey}
        className={cn('block size-8 shrink-0', !colour && 'bg-muted-foreground', className)}
        style={{
          ...(colour ? { backgroundColor: colour } : {}),
          WebkitMaskImage: image,
          maskImage: image,
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
        }}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      data-logo-badge={logoKey ?? ''}
      className={cn(
        'flex size-8 shrink-0 items-center justify-center rounded-md text-sm font-semibold',
        colour ? 'text-white' : 'bg-muted text-muted-foreground',
        className,
      )}
      style={colour ? { backgroundColor: colour } : undefined}
    >
      {Array.from(name.trim()).at(0)?.toUpperCase() ?? '?'}
    </span>
  );
}
